var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader-text"},[_c('p',[_vm._v(_vm._s(_vm.upperText))]),_c('p',[_vm._v(_vm._s(_vm.lowerText))]),_c('div',{staticClass:"loader-spinner"},[_c('common-logo-spinner',{attrs:{"width":88}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }